var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighlight2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84863 30.7236C5.51951 30.2024 5.35495 29.9419 5.26283 29.54C5.19364 29.2381 5.19364 28.762 5.26283 28.4601C5.35495 28.0582 5.51951 27.7977 5.84863 27.2765C8.56836 22.9701 16.6639 12.0834 29.001 12.0834C41.3381 12.0834 49.4336 22.9701 52.1533 27.2765C52.4824 27.7977 52.647 28.0582 52.7391 28.4601C52.8083 28.762 52.8083 29.2381 52.7391 29.54C52.647 29.9419 52.4824 30.2024 52.1533 30.7236C49.4336 35.03 41.3381 45.9167 29.001 45.9167C16.6639 45.9167 8.56836 35.03 5.84863 30.7236Z",
    stroke: "#0250AC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.001 36.25C33.005 36.25 36.251 33.0041 36.251 29C36.251 24.996 33.005 21.75 29.001 21.75C24.9969 21.75 21.751 24.996 21.751 29C21.751 33.0041 24.9969 36.25 29.001 36.25Z",
    stroke: "#0250AC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight2);
export default __webpack_public_path__ + "static/media/highlight2.dc5b8b1aa1b9a1d1c09d50fb5c865a09.svg";
export { ForwardRef as ReactComponent };